import React from 'react'
import StudentDash from '../../Components/StudentComponents/StudentDash/StudentDash'
import PredictForm from '../../Components/StudentComponents/PredictForm/PredictForm'

function PredictPage() {
  return (
    <StudentDash>
        <PredictForm/>
    </StudentDash>
  )
}

export default PredictPage